import React from 'react';
import XIcon from '../../../../Icons/icons/XIcon';

const SocialFilterChip = ({ title, value, onCrossClick }) => {
  return (
    <div className="sl-filter-chip">
      <div>
        <span className="sl-filter-chip-title">{title}:</span>{' '}
        <span className="sl-filter-chip-value">{value}</span>
      </div>
      <div onClick={onCrossClick} className="sl-filter-chip-cross-icon">
        <XIcon width={22} height={22} />
      </div>
    </div>
  );
};

export default SocialFilterChip;
